import PropTypes from 'prop-types';
import PriceProps from './price';

export default PropTypes.shape({
  long_name: PropTypes.string,
  short_name: PropTypes.string,
  fuel_product: PropTypes.string,
  credit: PriceProps,
});
